import { useMutation } from 'react-query';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import { api } from '../../api';
import { Event } from '../../models/event';
import {
  LOCALSTORAGE_CLIENT_ID,
  LOCALSTORAGE_CLIENT_SECRET,
  LOCALSTORAGE_USER_ID,
  LOCALSTORAGE_EVENTS,
} from '../../constants';

export const useCreateEventMutation = () => {
  const [clientId] = useLocalStorage<string>(LOCALSTORAGE_CLIENT_ID);
  const [clientSecret] = useLocalStorage<string>(LOCALSTORAGE_CLIENT_SECRET);
  const [userId] = useLocalStorage<number>(LOCALSTORAGE_USER_ID);
  const [events] = useLocalStorage<Event[]>(LOCALSTORAGE_EVENTS);

  return useMutation(
    ({
      title,
      destinations,
    }: {
      title: string;
      destinations: { rtmpUrl: string; streamKey: string }[];
    }) =>
      api.events.create({
        clientSecret,
        clientId,
        userId,
        title,
        destinations,
      }),
    {
      onSuccess: ({ eventId, guestUrl, hostUrl }, { destinations, title }) =>
        writeStorage(LOCALSTORAGE_EVENTS, [
          ...(events || []),
          {
            eventId,
            guestUrl,
            hostUrl,
            title,
            destinations,
          },
        ]),
    },
  );
};
